import moment from "moment";
import { ShowDates } from "../showDateUtils";
import { ExternalShowFormState, ShowFormState } from "./showFields";

const getNewShowDates = (defaultDate: moment.Moment | undefined): ShowDates => {
  const date = defaultDate ?? moment.utc().startOf("day");
  return {
    startDisplayDate: date.clone(),
    endDisplayDate: date.clone(),
    mode: "allDay",
    timeOfPerformance: "",
  };
};

export const getInitialShowFormState = (
    client: server.dto.ClientSmall,
    tour: server.dto.TourSmall | undefined,
    artist: server.dto.ArtistSmall | undefined,
    status: server.dto.StatusSmall,
    owner: server.dto.UserSmall,
    publicationStatus: server.dto.PublicationStatuses,
    defaultDate: moment.Moment | undefined,
): ShowFormState => ({
  client,
  // @ts-ignore
  tour,
  showDates: getNewShowDates(defaultDate),
  status,
  eventName: "",
  eventWebsite: "",
  publicationStatus,
  // @ts-ignore
  costCenter: null,
  projectCode: "",
  tags: [],
  owner,
  // @ts-ignore
  artist,
  attendees: [],
  // @ts-ignore
  venue: null,
  // @ts-ignore
  venueContact: null,
  // @ts-ignore
  capacity: null,
  // @ts-ignore
  ageRestriction: null,
  doors: {
    // @ts-ignore
    open: null,
    // @ts-ignore
    close: null,
  },
  // @ts-ignore
  promoter: null,
  // @ts-ignore
  promoterContact: null,
  // @ts-ignore
  hotel: null,
  // @ts-ignore
  hotelContact: null,
  onSaleDate: null,
  soldOut: false,
  ticketLink: "",
  presalePrice: null,
  doorPrice: null,
  reducedPrice: null,
  // @ts-ignore
  bookkeeping: null,
  currency: "eur",
  exchangeRate: 1,
  freefieldValues: [],
});

export const getInitialExternalShowFormState = (
    client: server.dto.ClientSmall,
    tour: server.dto.TourSmall | undefined,
    artist: server.dto.ArtistSmall | undefined,
    status: server.dto.StatusSmall,
    defaultDate: moment.Moment | undefined,
): ExternalShowFormState => ({
  client,
  // @ts-ignore
  tour,
  showDates: getNewShowDates(defaultDate),
  status,
  eventName: "",
  eventWebsite: "",
  // @ts-ignore
  artist,
  freefieldValues: [],
});
